// extracted by mini-css-extract-plugin
export default {"container":"PhoneNumber_container__Mr1rE"};